import './login.scss';
import LoginController from './login__controller';
import LoginRedirect from './login__redirect';
import InstallerResource from '../../blocks/resource/resource';

export default angular.module('installer.login', [InstallerResource.name]).
  controller('LoginController', LoginController).
  service('loginRedirect', LoginRedirect).
  config($routeProvider => {
    $routeProvider.when('/login', {
      controller: 'LoginController as ctrl',
      template: require('./login.html')
    });
  });




// WEBPACK FOOTER //
// ./src/pages/login/login.js